<template>
  <div id="page-product-documents-dynamic-form">
    <vs-row >
      <vs-col>
        <vs-row>
          <vs-col>
            <h2 class="mb-3">{{ pageTitle }}</h2>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col>
            <card-page>
              <vue-element-loading :active="busy"></vue-element-loading>
              <div class="flex justify-between">
                <div class="md:w-1/2 w-full">
                  <h3 v-if="isEdit" class="m-4">Edit {{ typeName }}</h3>
                  <vue-form-generator
                      :schema="schema"
                      :model="model"
                      :options="formOptions"
                      ref="form"
                  />
                </div>
                <div class="md:w-1/2 w-full">
                  <h3 class="m-4">Upload New File</h3>
                  <document-upload-form
                      :model="model"
                      ref="additional"
                  />
                </div>
              </div>
              <div class="w-full" v-if="isEdit">
                <document-grid
                    :apiModel="apiModel"
                    :model="model"
                />
              </div>
            </card-page>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import DocumentGrid from "@/views/pages/product-documents/DocumentGrid";
import DocumentUploadForm from "@/views/pages/product-documents/DocumentUploadForm";
import ProductDocumentUploadFormMixin from "@/components/mixins/ProductDocumentUploadFormMixin";
import FormModelMixin from "@/components/mixins/FormModelMixin";
import DynamicDocumentMixin from "@/components/mixins/DynamicDocumentMixin";
import CardPage from '../../../components/Views/CardPage';

export default {
  name: "DynamicForm",
  components: {
    DocumentGrid,
    DocumentUploadForm,
    CardPage,
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    forms: {
      type: Array,
      default: () => [
        'form',
      ]
    }
  },
  mixins: [DynamicDocumentMixin, FormModelMixin, ProductDocumentUploadFormMixin],
  data() {
    return {
      model: {
        DynamicType_FK: null,
        LoaderName: '',
        IsEnabled: 0,
        File: null,
        FriendlyName: null,
      },
      schema: {
        groups: [
          {
            styleClasses: "w-full",
            fields: [
              {
                type: "input",
                inputType: "text",
                styleClasses: "md:w-4/5 w-full",
                label: "Caption",
                model: "LoaderName",
                validator: 'string',
                required: true,
              },
            ],
          },
        ],
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
      },
      formReferences: this.forms,
    };
  },
  computed: {
    typeName() {
      if (!this.type) {
        return '';
      }

      return this.type.DisplayName || this.type.Type;
    },
    pageTitle() {
      if (!this.model || !this.typeName) {
        return '';
      }

      let mode = `Create a ${this.typeName} document`;

      if (this.model.hasOwnProperty("id") && this.model.id > 0) {
        mode = `${this.typeName} #${this.model.id}`
      }

      return mode;
    },
    isEdit() {
      return (this.model.hasOwnProperty("id") && this.model.id > 0);
    },
  },
  created() {
    this.model.DynamicType_FK = this.$route.params.typeId;
  }
};
</script>

<style scoped>

</style>
